(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	require('smooth-scroll');

	$('[data-smooth-scroll]').each(function () {
		var link = $(this);
		var headerHeight = 68;
		var offset = link.attr('data-smooth-scroll') || headerHeight;

		link.smoothScroll({
			offset: -offset
		});
	});
})();
